import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm._v("detail " + _vm._s(_vm.t('同公告')))]);
};

var staticRenderFns = [];
export { render, staticRenderFns };